import axios from 'axios';

import { API } from '@/config/constants';


export const getOrderSizes = async (config) => {
  const response = await axios.get(`${API}/order-sizes`, ...(config ? [config] : []));
  return response.data;
};

export const getManagedOrderSizes = async (config) => {
  const response = await axios.get(`${API}/order-sizes/manage`, ...(config ? [config] : []));
  return response.data;
};

export const updateOrderSizes = async (sizes, config) => {
  const response = await axios.put(`${API}/order-sizes`, { sizes }, ...(config ? [config] : []));
  return response.data;
};
